<template>
  <el-container class="layout-container" direction="vertical">
    <!-- 顶部导航栏 -->
    <el-header
      ref="headerRef"
      class="header"
      :class="{ 'header--nav-collapsed': headerNavCollapsed }"
    >
      <div class="header-left">
        <el-tooltip
          :content="
            headerNavCollapsed
              ? '展开：显示系统标题与常规菜单间距'
              : '收起：隐藏标题并压缩菜单字号，多出的菜单进「⋯」'
          "
          placement="bottom"
        >
          <el-button
            class="header-nav-toggle"
            text
            type="info"
            circle
            @click="headerNavCollapsed = !headerNavCollapsed; persistHeaderNavCollapsed(); scheduleClampShell()"
          >
            <el-icon v-if="!headerNavCollapsed" :size="18"><Fold /></el-icon>
            <el-icon v-else :size="18"><Expand /></el-icon>
          </el-button>
        </el-tooltip>
        <span class="system-title">纺织贸易ERP系统</span>
        <div ref="topMenuWrapRef" class="top-menu-wrap">
        <el-menu
          ref="topMenuRef"
          router
          mode="horizontal"
          :ellipsis="true"
          default-active="/dashboard"
          class="top-menu"
          text-color="#fff"
          active-text-color="#FFD700"
          popper-class="top-menu-overflow-popper"
        >
          <el-menu-item index="/dashboard">
            <el-icon><house /></el-icon>
            <span>系统首页</span>
          </el-menu-item>
          <el-menu-item v-if="canAccess('tasks.view')" index="/tasks">
            <el-badge :value="taskBadge.pending" :hidden="!taskBadge.pending" :max="999999">
              <span>任务中心</span>
            </el-badge>
          </el-menu-item>
          <el-menu-item v-if="canAccessDesktopMobile" index="/desktop-mobile">
            <span>移动工作台</span>
          </el-menu-item>
          
          <el-sub-menu v-if="showOrdersMenu" index="1">
            <template #title>
              <el-icon><document /></el-icon>
              <span>订单管理</span>
            </template>
            <el-menu-item v-if="canAccess('orders.sales.view')" index="/orders">销售订单</el-menu-item>
            <el-menu-item v-if="canAccess('global.admin')" index="/admin/order-item-client-material-name-sync">
              客户产品名称同步
            </el-menu-item>
            <el-menu-item v-if="canAccess('global.admin')" index="/admin/matching-batch-correction">
              配料料号纠正
            </el-menu-item>
            <el-menu-item v-if="canAccess('global.admin')" index="/admin/dispatch-site-capacity">
              现场派工产能
            </el-menu-item>
            <el-menu-item v-if="canAccess('orders.material_matching.view')" index="/orders/material-matching">配料管理</el-menu-item>
            <el-menu-item v-if="canAccess('orders.material_matching.view')" index="/orders/material-matching-query">配料查询</el-menu-item>
            <el-menu-item
              v-if="
                canAccess('orders.sales.view') ||
                canAccess('orders.material_matching.view') ||
                canAccess('orders.dispatch.view') ||
                canAccess('orders.delivery.view')
              "
              index="/orders/item-tracking"
            >
              订单明细追踪
            </el-menu-item>
            <el-menu-item
              v-if="
                canAccess('orders.sales.view') ||
                canAccess('orders.material_matching.view') ||
                canAccess('orders.dispatch.view') ||
                canAccess('orders.delivery.view')
              "
              index="/orders/order-summary"
            >
              订单汇总表
            </el-menu-item>
            <el-menu-item
              v-if="
                canAccess('orders.sales.view') ||
                canAccess('orders.material_matching.view') ||
                canAccess('orders.dispatch.view') ||
                canAccess('orders.delivery.view')
              "
              index="/orders/order-forecasts"
            >
              预告订单
            </el-menu-item>
            <el-menu-item v-if="canAccess('orders.color_confirmation.view')" index="/orders/color-confirmation">颜色确认登记</el-menu-item>
            <el-menu-item v-if="canAccess('orders.dispatch.view')" index="/orders/dispatch-order">派工单管理</el-menu-item>
            <el-menu-item v-if="canAccess('orders.delivery.view')" index="/orders/delivery-orders">出库单管理</el-menu-item>
            <el-menu-item
              v-if="canAccess('orders.customer_return.view') || canAccess('orders.delivery.view')"
              index="/orders/customer-returns"
            >
              客户退货
            </el-menu-item>
            <el-menu-item
              v-if="
                canAccess('orders.delivery.sync_price.review') ||
                canAccess('orders.delivery.sync_price.request')
              "
              index="/orders/delivery-unit-price-sync"
            >
              送货单价/染费同步审批
            </el-menu-item>
            <el-menu-item v-if="canAccess('orders.delivery.view')" index="/orders/packing-lists">包装资料管理</el-menu-item>
            <el-menu-item index="/orders/update-requests">订单更新请求</el-menu-item>
            <el-menu-item index="/quotes">报价管理</el-menu-item>
            <el-menu-item v-if="canAccess('pricing.view')" index="/pricing/material-prices">单价管理</el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu v-if="showPurchaseMenu" index="2">
            <template #title>
              <el-icon><shopping-cart /></el-icon>
              <span>采购管理</span>
            </template>
            <el-menu-item v-if="canAccess('purchase.orders.view')" index="/purchase/orders">采购订单</el-menu-item>
            <el-menu-item v-if="canAccess('purchase.return.view')" index="/purchase/returns">采购退货</el-menu-item>
            <el-menu-item v-if="canAccess('purchase.tracking.view')" index="/purchase/orders/tracking">采购订单明细追踪</el-menu-item>
            <el-menu-item v-if="canAccess('purchase.suppliers.view')" index="/suppliers">供应商管理</el-menu-item>
            <el-menu-item v-if="canAccess('orders.material_matching.view')" index="/purchase/processing-orders">加工单管理</el-menu-item>
            <el-menu-item
              v-if="canAccess('purchase.processing_follow.view') || canAccess('orders.material_matching.view')"
              index="/purchase/processing-follow-up"
            >
              加工跟进
            </el-menu-item>
            <el-menu-item
              v-if="canAccess('purchase.market_procurement.view') || canAccess('orders.material_matching.view')"
              index="/purchase/market-procurement-follow-up"
            >
              市场采购跟进
            </el-menu-item>
            <el-menu-item
              v-if="canAccess('purchase.color_formulation.view') || canAccess('orders.material_matching.view')"
              index="/purchase/color-formulation-follow-up"
            >
              配色跟进
            </el-menu-item>
            <el-menu-item v-if="canAccess('inventory.material_batches.view')" index="/purchase/material-processing-relations">
              材料加工关系
            </el-menu-item>
          </el-sub-menu>

          <el-sub-menu v-if="showFinanceMenu" index="finance">
            <template #title>
              <el-icon><Money /></el-icon>
              <span>财务管理</span>
            </template>
            <el-menu-item v-if="canAccessFinance('finance.reconciliation.view')" index="/finance/reconciliation">应收应付看板</el-menu-item>
            <el-menu-item
              v-if="canShowMyReceivablesMenu"
              index="/finance/my-receivables"
            >
              我的客户应收
            </el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.overview.view')" index="/finance/overview">财务工作台</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.monthly_report.view')" index="/finance/monthly-report">财务月报</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.statement_variance.view')" index="/finance/statement-variance">账单与财务差异</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.partner_balances.view')" index="/finance/partner-balances">往来单位应收应付</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.partner_ledger.view')" index="/finance/partner-ledger">往来明细账</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.receipt.view')" index="/finance/documents/receipt">收款单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.payment.view')" index="/finance/documents/payment">付款单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.expense.view')" index="/finance/documents/expense">费用单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.advance_receipt.view')" index="/finance/documents/advance-receipt">预收款单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.advance_payment.view')" index="/finance/documents/advance-payment">预付款单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.other_income.view')" index="/finance/documents/other-income">其它收入单</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.documents.cash_transfer.view')" index="/finance/documents/cash-transfer">提现·存现·转账</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.vouchers.view')" index="/finance/vouchers">会计凭证</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.accounts.view')" index="/finance/accounts">会计科目配置</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.expense_items.view')" index="/finance/expense-items">报销费用科目</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.reimbursement_settings.view')" index="/finance/reimbursement-settings">报账规则设置</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.account_balances.view')" index="/finance/account-balances">科目余额表</el-menu-item>
            <el-menu-item v-if="canAccessFinance('finance.cash_reimbursement.view')" index="/finance/cash-reimbursements">现金报账审核</el-menu-item>
            <el-menu-item v-if="canViewBillingDocumentCenter()" index="/billing/document-center">单据中心</el-menu-item>
            <el-menu-item v-if="canViewBillingStatements('receivable')" index="/billing/statements/receivable">应收账单</el-menu-item>
            <el-menu-item v-if="canViewBillingStatements('payable')" index="/billing/statements/payable">应付账单</el-menu-item>
            <el-menu-item v-if="canViewBillingPrepayment()" index="/billing/prepayment">预付请款</el-menu-item>
            <el-menu-item v-if="canViewPaymentFooterAccounts()" index="/billing/payment-footer-accounts">收款账户库</el-menu-item>
          </el-sub-menu>

          <el-sub-menu v-if="canViewTaxInvoices()" index="tax-invoices">
            <template #title>
              <el-icon><Document /></el-icon>
              <span>税票管理</span>
            </template>
            <el-menu-item index="/billing/tax-invoices/vendors">开票厂商</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/customers">开票客户</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/products">税票品名</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/inbound">进项发票</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/outbound">销项发票</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/matches">税票核销</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/inventory">税票库存台账</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/yearly-stock">税票品名年度库存</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/item-merge-groups">品名合并设定</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/outbound-gaps">销项配齐跟进</el-menu-item>
            <el-menu-item index="/billing/tax-invoices/report">税票期间汇总</el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu v-if="showInventoryMenu" index="inventory">
            <template #title>
              <el-icon><box /></el-icon>
              <span>库存管理</span>
            </template>
            <el-menu-item v-if="canAccess('inventory.locations.view')" index="/inventory/storage-locations">库位管理</el-menu-item>
            <el-menu-item v-if="canAccess('inventory.locations.view')" index="/inventory/warehouse-layout">仓库平面视图</el-menu-item>
            <el-menu-item v-if="canAccess('inventory.material_batches.view')" index="/inventory/material-identities">材料身份管理</el-menu-item>
            <!-- 预分配料号系统 - 料号管理 -->
            <el-menu-item v-if="canAccess('inventory.material_batches.view')" index="/inventory/material-batches">料号管理</el-menu-item>
            <el-menu-item
              v-if="
                canAccess('inventory.material_batches.identity_correction') ||
                canAccess('global.admin')
              "
              index="/inventory/batch-identity-correction"
            >
              料号身份纠错
            </el-menu-item>
            <el-menu-item v-if="canAccess('inventory.records.view')" index="/inventory/material-inventory">材料库存管理</el-menu-item>
            <el-menu-item v-if="canAccess('inventory.records.view')" index="/inventory/dispatch-virtual-balance">派工完成虚库核对</el-menu-item>
            <el-menu-item
              v-if="
                canAccess('inventory.manual_code_intake.view') ||
                canAccess('inventory.manual_code_intake.process') ||
                canAccess('inventory.records.view')
              "
              index="/inventory/manual-code-intake-requests"
            >
              盘点未知料号入库申请
            </el-menu-item>
            <el-menu-item
              v-if="
                canAccess('inventory.operation_approval.review') ||
                canAccess('inventory.operation_approval.initial_review') ||
                canAccess('global.admin')
              "
              index="/inventory/operation-approval-requests"
            >
              库存出入库审批
            </el-menu-item>
            <!-- 新增库存操作中心菜单项 -->
            <el-menu-item v-if="canAccess('inventory.operations.edit')" index="/inventory/operations">
              <el-icon><operation /></el-icon>
              <span>库存操作中心</span>
            </el-menu-item>
            <el-menu-item v-if="canAccess('inventory.operations.view')" index="/inventory/inventory-transactions">库存交易记录</el-menu-item>
            <el-menu-item v-if="canAccess('inventory.operations.view')" index="/inventory/transaction-types">交易类型管理</el-menu-item>
            <el-menu-item v-if="canAccess('inventory.records.view')" index="/inventory/inventory-summary">库存汇总报表</el-menu-item>
          </el-sub-menu>

          <el-sub-menu v-if="showReportsMenu" index="reports">
            <template #title>
              <el-icon><DataAnalysis /></el-icon>
              <span>报表</span>
            </template>
            <el-menu-item index="/reports">报表中心</el-menu-item>
            <el-menu-item index="/reports/gain-loss">报损报溢核对</el-menu-item>
            <el-menu-item index="/reports/brand-season">品牌季度报表</el-menu-item>
          </el-sub-menu>
          
          <!-- 基础资料菜单 -->
          <el-sub-menu v-if="showBasicDataMenu" index="basic-data">
            <template #title>
              <el-icon><setting /></el-icon>
              <span>基础资料</span>
            </template>
            <el-menu-item index="/basic-data">资料总览</el-menu-item>
            <el-menu-item v-if="canAccess('customers.brands.view')" index="/brands">品牌管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.colors.view')" index="/colors">颜色管理</el-menu-item>
            <el-menu-item v-if="canAccess('customers.records.view')" index="/customers">客户管理</el-menu-item>
            <el-menu-item v-if="canAccess('purchase.suppliers.view')" index="/suppliers">供应商管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.materials.view')" index="/materials">材料管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.material_customer_names.view')" index="/material-customer-names">客户材料名称管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.order_types.view')" index="/order-types">订单类型</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.seasons.view')" index="/seasons">季节管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.units.view')" index="/units">单位管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.unit_conversions.view')" index="/unit-conversions">单位换算规则</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.numbering_rules.view')" index="/numbering-rules">编码规则</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.tax_classifications.view')" index="/tax-classifications">税务分类</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.print_templates.view')" index="/print-templates">打印模板管理</el-menu-item>
            <el-menu-item v-if="canAccess('masterdata.specifications.view')" index="/specification-templates">规格主数据</el-menu-item>
          </el-sub-menu>
          
          <el-menu-item index="/products">
            <el-icon><goods /></el-icon>
            <span>其他库存</span>
          </el-menu-item>
          <el-menu-item v-if="canAccess('quality.test_reports.view')" index="/quality/test-reports">
            <el-icon><document /></el-icon>
            <span>测试报告</span>
          </el-menu-item>
          
          <!-- 用户权限管理菜单（仅管理员） -->
          <el-sub-menu v-if="canManageUsersAndRoles()" index="permissions">
            <template #title>
              <el-icon><user /></el-icon>
              <span>用户权限管理</span>
            </template>
            <el-menu-item index="/permissions">用户管理</el-menu-item>
          </el-sub-menu>
        </el-menu>
        </div>
      </div>
      <div ref="headerRightRef" class="header-right">
        <el-tooltip
          placement="bottom"
          :content="
            fullscreenActive
              ? '退出全屏（Esc 也可）'
              : '进入浏览器全屏，增大工作区'
          "
        >
          <el-button
            class="header-fullscreen-btn"
            text
            type="info"
            size="small"
            @click="toggleBrowserFullscreen"
          >
            <el-icon v-if="!fullscreenActive" :size="16"><FullScreen /></el-icon>
            <el-icon v-else :size="16"><Close /></el-icon>
          </el-button>
        </el-tooltip>
        <el-popover
          placement="bottom-end"
          :width="280"
          trigger="click"
          popper-class="header-display-popper"
        >
          <template #reference>
            <el-button class="header-display-btn" text type="info" size="small" title="显示设置">
              <el-icon :size="16"><Setting /></el-icon>
            </el-button>
          </template>
          <div class="header-display-panel">
            <div class="header-display-row" title="进入系统时弹出一次全屏确认">
              <span class="header-display-row__label">进系统问全屏</span>
              <el-switch
                v-model="promptFullscreenOnEnter"
                size="small"
                @change="persistPromptFullscreenOnEnter"
              />
            </div>
            <div class="header-display-row" title="减小主内容区内边距，表格更宽">
              <span class="header-display-row__label">主区边距</span>
              <el-switch
                v-model="mainContentCompact"
                @change="persistMainContentCompact"
                size="small"
                inline-prompt
                active-text="紧凑"
                inactive-text="默认"
              />
            </div>
            <div class="header-display-row header-display-row--stack" title="宽表格超出窗口时：表内横滑，或整体缩小以看全貌（不依赖浏览器全屏）">
              <span class="header-display-row__label">主区过宽</span>
              <el-radio-group v-model="layoutMode" size="small" class="header-layout-rg">
                <el-radio-button label="scroll">表内横滑</el-radio-button>
                <el-radio-button label="fit">整体缩小</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-popover>
        <el-dropdown v-if="canViewOnlineOverview" trigger="click" @visible-change="handleOnlineDropdownVisible">
          <span class="online-users-link">
            在线 {{ onlineOverview.online_user_count }}
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu class="online-users-dropdown">
              <el-dropdown-item disabled class="online-users-dropdown__section">
                当前在线 · {{ onlineOverview.online_user_count }} 人
              </el-dropdown-item>
              <el-dropdown-item
                v-for="u in onlineOverview.online_users"
                :key="'on-' + u.user_id"
                disabled
                class="online-users-dropdown__item online-users-dropdown__item--live"
              >
                <span class="online-users-dropdown__name">{{ u.full_name || u.username }}</span>
                <span class="online-users-dropdown__devices">
                  {{ u.desktop_online ? '电脑' : '' }}{{ u.desktop_online && u.mobile_online ? '/' : '' }}{{ u.mobile_online ? '手机' : '' }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="!onlineOverview.online_users.length"
                disabled
                class="online-users-dropdown__item online-users-dropdown__empty"
              >
                暂无在线用户
              </el-dropdown-item>

              <template v-if="onlineOverview.recent_offline_users.length">
                <el-dropdown-item disabled class="online-users-dropdown__section online-users-dropdown__section--secondary">
                  曾登录 · 当前不在线
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="u in onlineOverview.recent_offline_users"
                  :key="'off-' + u.user_id"
                  disabled
                  class="online-users-dropdown__item online-users-dropdown__item--away"
                >
                  <span class="online-users-dropdown__name">{{ u.full_name || u.username }}</span>
                  <span class="online-users-dropdown__meta">上次登录 {{ formatOfflineLogin(u.last_login_at) }}</span>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown>
          <span class="el-dropdown-link">
            <el-avatar :size="28" class="header-user-avatar" />
            <span class="header-user-name">{{ currentUserName }}</span>
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>个人中心</el-dropdown-item>
              <el-dropdown-item @click="goChangePassword">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click="handleLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 标签页栏 -->
    <TabsView />

    <!-- 主内容区域：不用 el-main（EP 默认 overflow:auto + flex-basis:auto 易叠双滚动条） -->
    <div class="main-content" :class="{ 'main-content--compact': mainContentCompact }">
      <div
        ref="viewportRef"
        class="main-viewport"
        :class="[
          `main-viewport--${layoutMode}`,
          { 'main-viewport--nested-scroll': isDesktopMobileRoute }
        ]"
      >
        <div ref="fitBridgeRef" class="main-viewport__bridge" :style="bridgeStyle">
          <div ref="fitInnerRef" class="main-viewport__inner" :style="innerStyle">
            <router-view v-slot="{ Component, route }">
              <keep-alive>
                <component :is="Component" :key="route.path" />
              </keep-alive>
            </router-view>
          </div>
        </div>
      </div>
    </div>

    <SiteBeianFooter />
  </el-container>
</template>

<script>
import {
  House,
  Document,
  ShoppingCart,
  Box,
  Goods,
  ArrowDown,
  Setting,
  Operation,
  User,
  Fold,
  Expand,
  FullScreen,
  Close,
  Money,
  DataAnalysis
} from '@element-plus/icons-vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { watch, onMounted, onUnmounted, computed, ref, nextTick } from 'vue'
import TabsView from '@/components/TabsView.vue'
import SiteBeianFooter from '@/components/SiteBeianFooter.vue'
import { useTabs } from '@/composables/useTabs'
import {
  hasPermission,
  canAccessFinanceModuleKey,
  hasRawPermission,
  canViewBillingStatements as userCanViewBillingStatements,
  canViewBillingPrepayment as userCanViewBillingPrepayment,
  canViewBillingDocumentCenter as userCanViewBillingDocumentCenter,
  canViewPaymentFooterAccounts as userCanViewPaymentFooterAccounts,
  canViewTaxInvoices as userCanViewTaxInvoices,
  canAccessAnyFinanceMenu,
  canManageUsersAndRoles as userCanManageUsersAndRoles
} from '@/utils/permission'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import { getStoredLayoutMode, setStoredLayoutMode } from '@/utils/layoutMode'
import { getTaskBadgeCount } from '@/api/taskEvents'
import { canAccessDesktopMobileWorkbench } from '@/utils/mobileAccess'
import { tryImportLocalPackingBatches } from '@/utils/packingListLocalImport'
import request from '@/utils/request'
import { getOnlineUsersOverview } from '@/api/users'

export default {
  name: 'MainLayout',
  components: {
    House,
    Document,
    ShoppingCart,
    Box,
    Goods,
    ArrowDown,
    Setting,
    Operation,
    User,
    Fold,
    Expand,
    FullScreen,
    Close,
    Money,
    DataAnalysis,
    TabsView,
    SiteBeianFooter
  },
  setup() {
    const router = useRouter()
    const userStore = useUserStore()
    userStore.initFromStorage()
    const { user: currentUser } = storeToRefs(userStore)
    const currentUserName = computed(() => {
      const u = currentUser.value
      return u?.full_name || u?.username || '用户'
    })
    const canAccess = (permissionKey) => hasPermission(currentUser.value, permissionKey)
    const canAccessFinance = (permissionKey) =>
      canAccessFinanceModuleKey(currentUser.value, permissionKey)
    const canViewOnlineOverview = computed(() => !!(currentUser.value?.is_admin || currentUser.value?.is_superuser))
    const showOrdersMenu = computed(
      () =>
        canAccess('orders.sales.view') ||
        canAccess('orders.material_matching.view') ||
        canAccess('orders.dispatch.view') ||
        canAccess('orders.delivery.view') ||
        canAccess('orders.color_confirmation.view') ||
        canAccess('pricing.view') ||
        canAccess('global.admin')
    )
    const showPurchaseMenu = computed(
      () =>
        canAccess('purchase.orders.view') ||
        canAccess('purchase.return.view') ||
        canAccess('purchase.tracking.view') ||
        canAccess('purchase.suppliers.view') ||
        canAccess('purchase.processing_follow.view') ||
        canAccess('orders.material_matching.view') ||
        canAccess('inventory.material_batches.view')
    )
    const showInventoryMenu = computed(
      () =>
        canAccess('inventory.records.view') ||
        canAccess('inventory.operations.view') ||
        canAccess('inventory.material_batches.view') ||
        canAccess('inventory.material_batches.identity_correction') ||
        canAccess('inventory.locations.view') ||
        canAccess('inventory.manual_code_intake.view') ||
        canAccess('inventory.manual_code_intake.process') ||
        canAccess('global.admin')
    )
    const showReportsMenu = computed(
      () =>
        canAccess('reports.view') ||
        canAccess('reports.gain_loss.view') ||
        canAccess('inventory.records.view') ||
        canAccess('inventory.operations.view') ||
        canAccess('global.admin')
    )
    const canViewBillingStatements = (direction) => userCanViewBillingStatements(currentUser.value, direction)
    const canManageUsersAndRoles = () => userCanManageUsersAndRoles(currentUser.value)
    const canViewBillingPrepayment = () => userCanViewBillingPrepayment(currentUser.value)
    const canViewBillingDocumentCenter = () => userCanViewBillingDocumentCenter(currentUser.value)
    const canViewPaymentFooterAccounts = () => userCanViewPaymentFooterAccounts(currentUser.value)
    const canViewTaxInvoices = () => userCanViewTaxInvoices(currentUser.value)
    const showFinanceMenu = computed(() => canAccessAnyFinanceMenu(currentUser.value))
    const canShowMyReceivablesMenu = computed(() => {
      const u = currentUser.value
      return (
        canAccessFinanceModuleKey(u, 'finance.receivables.view') &&
        !canAccessFinanceModuleKey(u, 'finance.reconciliation.view') &&
        !hasRawPermission(u, 'finance.view')
      )
    })
    const showBasicDataMenu = computed(() =>
      canAccess('customers.records.view') ||
      canAccess('customers.brands.view') ||
      canAccess('purchase.suppliers.view') ||
      canAccess('masterdata.colors.view') ||
      canAccess('masterdata.materials.view') ||
      canAccess('masterdata.material_customer_names.view') ||
      canAccess('masterdata.order_types.view') ||
      canAccess('masterdata.seasons.view') ||
      canAccess('masterdata.units.view') ||
      canAccess('masterdata.unit_conversions.view') ||
      canAccess('masterdata.numbering_rules.view') ||
      canAccess('masterdata.tax_classifications.view') ||
      canAccess('masterdata.print_templates.view') ||
      canAccess('masterdata.specifications.view') ||
      canAccess('global.admin')
    )

    const goChangePassword = () => {
      router.push('/change-password')
    }

    const route = useRoute()
    const isDesktopMobileRoute = computed(() =>
      String(route.path || '').startsWith('/desktop-mobile')
    )
    const { addTab, initTabs, removeTab, tabs } = useTabs()

    const LAYOUT_STORAGE_HEADER_NAV = 'layout_header_nav_collapsed'
    const LAYOUT_STORAGE_MAIN_COMPACT = 'layout_main_content_compact'
    const LAYOUT_STORAGE_PROMPT_FULLSCREEN = 'layout_prompt_fullscreen_on_enter'
    const SESSION_FS_ASKED_KEY = 'layout_fs_prompt_asked_session_v1'

    const headerNavCollapsed = ref(false)
    const mainContentCompact = ref(false)
    const fullscreenActive = ref(false)
    const promptFullscreenOnEnter = ref(false)

    const getFullscreenElement = () =>
      document.fullscreenElement || document.webkitFullscreenElement || null

    const syncFullscreenActive = () => {
      fullscreenActive.value = !!getFullscreenElement()
    }

    const toggleBrowserFullscreen = async () => {
      try {
        const current = getFullscreenElement()
        const el = document.documentElement
        if (!current) {
          if (typeof el.requestFullscreen === 'function') {
            await el.requestFullscreen()
          } else if (typeof el.webkitRequestFullscreen === 'function') {
            await el.webkitRequestFullscreen()
          } else {
            throw new Error('no-fs-api')
          }
        } else if (typeof document.exitFullscreen === 'function') {
          await document.exitFullscreen()
        } else if (typeof document.webkitExitFullscreen === 'function') {
          await document.webkitExitFullscreen()
        }
      } catch {
        ElMessage.warning('当前环境无法切换浏览器全屏，请使用浏览器自带全屏或使用 F11（视浏览器而定）')
      }
    }

    const persistPromptFullscreenOnEnter = () => {
      try {
        localStorage.setItem(LAYOUT_STORAGE_PROMPT_FULLSCREEN, promptFullscreenOnEnter.value ? '1' : '0')
      } catch (e) {
        /* ignore */
      }
    }

    const loadLayoutChromePrefs = () => {
      try {
        headerNavCollapsed.value = localStorage.getItem(LAYOUT_STORAGE_HEADER_NAV) === '1'
        mainContentCompact.value = localStorage.getItem(LAYOUT_STORAGE_MAIN_COMPACT) === '1'
        promptFullscreenOnEnter.value = localStorage.getItem(LAYOUT_STORAGE_PROMPT_FULLSCREEN) === '1'
      } catch (e) {
        /* ignore */
      }
    }

    const persistHeaderNavCollapsed = () => {
      try {
        localStorage.setItem(LAYOUT_STORAGE_HEADER_NAV, headerNavCollapsed.value ? '1' : '0')
      } catch (e) {
        /* ignore */
      }
      nextTick(() => {
        scheduleMainLayoutUpdate()
        refreshTopMenuEllipsis()
      })
    }

    const persistMainContentCompact = () => {
      try {
        localStorage.setItem(LAYOUT_STORAGE_MAIN_COMPACT, mainContentCompact.value ? '1' : '0')
      } catch (e) {
        /* ignore */
      }
      nextTick(() => scheduleMainLayoutUpdate())
    }

    const layoutMode = ref(getStoredLayoutMode())
    const viewportRef = ref(null)
    const fitBridgeRef = ref(null)
    const fitInnerRef = ref(null)
    const topMenuRef = ref(null)
    const headerRef = ref(null)
    const headerRightRef = ref(null)
    const topMenuWrapRef = ref(null)
    const bridgeStyle = ref({})
    const innerStyle = ref({})

    let layoutResizeTimer = null
    let layoutResizeObserver = null
    let layoutWindowResizeHandler = null
    let menuResizeTimer = null
    let shellClampTimer = null
    let lockWindowScrollHandler = null

    const unwrapEl = (val) => {
      if (!val) return null
      if (val instanceof HTMLElement) return val
      if (val.$el instanceof HTMLElement) return val.$el
      return null
    }

    /**
     * 顶栏菜单与窗口宽度的「鸡生蛋」：菜单不限宽会撑开整页，父级变宽后
     * Element Plus ellipsis 又认为「够宽」不再折叠。这里用 window.innerWidth
     * 先钉死外壳，再给菜单区写死可用像素宽，强制折叠到「⋯」。
     */
    const clampShellToWindow = () => {
      const winW = Math.max(320, Math.floor(window.innerWidth || document.documentElement.clientWidth || 0))
      const winH = Math.max(320, Math.floor(window.innerHeight || document.documentElement.clientHeight || 0))
      try {
        document.documentElement.style.setProperty('--erp-shell-w', `${winW}px`)
        document.documentElement.style.setProperty('--erp-shell-h', `${winH}px`)
        document.documentElement.classList.add('erp-no-doc-scroll')
        document.documentElement.style.overflow = 'hidden'
        document.documentElement.style.height = '100%'
        document.documentElement.style.maxHeight = '100%'
        document.body.style.overflow = 'hidden'
        document.body.style.maxWidth = `${winW}px`
        document.body.style.height = '100%'
        document.body.style.maxHeight = '100%'
        // 窗口级若已滚过，立刻归零（否则会与 .main-viewport 叠出双竖条）
        if (window.scrollX || window.scrollY) {
          window.scrollTo(0, 0)
        }
        if (document.documentElement.scrollTop || document.body.scrollTop) {
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        }
      } catch (e) {
        /* ignore */
      }

      const headerEl = unwrapEl(headerRef.value)
      const rightEl = headerRightRef.value
      const wrapEl = topMenuWrapRef.value
      if (headerEl) {
        headerEl.style.width = `${winW}px`
        headerEl.style.maxWidth = `${winW}px`
      }
      if (headerEl && rightEl && wrapEl) {
        const rightW = Math.ceil(rightEl.getBoundingClientRect().width || rightEl.offsetWidth || 0)
        const leftExtras = headerEl.querySelector('.header-nav-toggle')
        const titleEl = headerEl.querySelector('.system-title')
        const toggleW = leftExtras ? Math.ceil(leftExtras.getBoundingClientRect().width) + 4 : 28
        const titleVisible = titleEl && getComputedStyle(titleEl).display !== 'none'
        const titleW = titleVisible ? Math.ceil(titleEl.getBoundingClientRect().width) + 8 : 0
        const avail = Math.max(80, winW - rightW - toggleW - titleW - 12)
        wrapEl.style.width = `${avail}px`
        wrapEl.style.maxWidth = `${avail}px`
        wrapEl.style.minWidth = '0'
        wrapEl.style.overflow = 'hidden'
        const menuRoot = wrapEl.querySelector('.top-menu.el-menu')
        if (menuRoot) {
          menuRoot.style.width = `${avail}px`
          menuRoot.style.maxWidth = `${avail}px`
        }
      }
      refreshTopMenuEllipsis()
    }

    const scheduleClampShell = () => {
      clearTimeout(shellClampTimer)
      shellClampTimer = setTimeout(() => {
        nextTick(() => {
          clampShellToWindow()
          // 菜单项宽测完后再夹一次，避免右侧工具未稳定导致可用宽偏大
          setTimeout(clampShellToWindow, 50)
          setTimeout(clampShellToWindow, 200)
        })
      }, 16)
    }

    const refreshTopMenuEllipsis = () => {
      clearTimeout(menuResizeTimer)
      menuResizeTimer = setTimeout(() => {
        try {
          topMenuRef.value?.handleResize?.()
        } catch (e) {
          /* ignore */
        }
      }, 50)
    }
    let taskBadgeTimer = null
    const taskBadge = ref({ unread: 0, pending: 0, overdue: 0 })
    let onlineOverviewTimer = null
    const onlineOverview = ref({
      online_user_count: 0,
      online_users: [],
      recent_offline_users: []
    })

    const formatOfflineLogin = (iso) => {
      if (!iso) return '—'
      const d = new Date(iso)
      if (Number.isNaN(d.getTime())) return String(iso)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }

    function scheduleMainLayoutUpdate() {
      clearTimeout(layoutResizeTimer)
      layoutResizeTimer = setTimeout(() => {
        nextTick(() => {
          nextTick(() => {
            updateMainLayout()
          })
        })
      }, 100)
    }

    function updateMainLayout() {
      const vp = viewportRef.value
      const bridge = fitBridgeRef.value
      const inner = fitInnerRef.value
      if (!vp || !bridge || !inner) return

      // 始终先按窗口可用宽度铺满——禁止 width:max-content（会使 CSS Grid 无限变宽）
      const resetFullWidth = () => {
        bridgeStyle.value = {
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          overflow: 'visible',
          position: 'relative'
        }
        innerStyle.value = {
          width: '100%',
          maxWidth: '100%',
          transform: 'none',
          transformOrigin: 'top left',
          position: 'relative',
          display: 'block',
          visibility: 'visible'
        }
      }

      if (layoutMode.value === 'scroll') {
        resetFullWidth()
        return
      }

      // 缩放适应：在「已限制为 100% 宽」的前提下量 scrollWidth，再整体缩小
      resetFullWidth()
      nextTick(() => {
        if (layoutMode.value !== 'fit') return
        const vp2 = viewportRef.value
        const inner2 = fitInnerRef.value
        if (!vp2 || !inner2) return

        const avail = Math.max(320, vp2.clientWidth)
        const W = Math.max(1, inner2.scrollWidth)
        const H = Math.max(1, inner2.scrollHeight)
        if (W <= avail + 2) return

        const s = Math.max(0.45, Math.min(1, avail / W))
        innerStyle.value = {
          width: `${W}px`,
          maxWidth: 'none',
          transform: `scale(${s})`,
          transformOrigin: 'top left',
          position: 'relative',
          display: 'block',
          visibility: 'visible'
        }
        bridgeStyle.value = {
          width: '100%',
          maxWidth: '100%',
          height: `${Math.ceil(H * s)}px`,
          overflow: 'hidden',
          position: 'relative'
        }
      })
    }

    watch(headerNavCollapsed, () => {
      scheduleClampShell()
    })

    watch(layoutMode, (v) => {
      setStoredLayoutMode(v)
      if (v === 'scroll') {
        clearTimeout(layoutResizeTimer)
        bridgeStyle.value = {}
        innerStyle.value = {}
      } else {
        scheduleMainLayoutUpdate()
      }
      scheduleClampShell()
    })

    const refreshUserOnTabVisible = () => {
      if (document.visibilityState === 'visible') {
        userStore.syncUserFromServer({ force: true })
        refreshTaskBadge()
      }
    }

    const refreshTaskBadge = async () => {
      if (!canAccess('tasks.view')) return
      try {
        const res = await getTaskBadgeCount()
        taskBadge.value = res.data || { unread: 0, pending: 0, overdue: 0 }
      } catch {
        /* ignore */
      }
    }

    const refreshOnlineOverview = async () => {
      if (!canViewOnlineOverview.value) return
      try {
        const res = await getOnlineUsersOverview()
        if (res.success && res.data) {
          onlineOverview.value = {
            online_user_count: Number(res.data.online_user_count || 0),
            online_users: Array.isArray(res.data.online_users) ? res.data.online_users : [],
            recent_offline_users: Array.isArray(res.data.recent_offline_users)
              ? res.data.recent_offline_users
              : []
          }
        }
      } catch {
        /* ignore */
      }
    }

    const handleOnlineDropdownVisible = (visible) => {
      if (visible) refreshOnlineOverview()
    }

    // 初始化标签页
    onMounted(() => {
      // 便于你在控制台确认是否已加载新前端（F12 → Console）
      try {
        console.info('[ERP] frontend build marker: restore-h-scroll-20260717')
      } catch (e) {
        /* ignore */
      }
      // 禁止窗口级滚动（双竖条根因：window.scrollY≠0 + .main-viewport）
      lockWindowScrollHandler = () => {
        if (window.scrollX || window.scrollY) window.scrollTo(0, 0)
      }
      window.addEventListener('scroll', lockWindowScrollHandler, { passive: true })
      lockWindowScrollHandler()
      // 清掉历史会话留下的整页横滑锁（会裁掉右侧又拖不到）
      try {
        document.documentElement.classList.remove('erp-desktop-shell')
        document.body.classList.remove('erp-desktop-shell')
        document.getElementById('erp-desktop-shell-lock-style')?.remove()
      } catch (e) {
        /* ignore */
      }
      loadLayoutChromePrefs()
      initTabs()
      // 切换账号后若残留无权限页签（如用户权限管理），立刻去掉
      if (!canManageUsersAndRoles()) {
        const paths = (tabs.value || [])
          .filter((t) => String(t.path || '').startsWith('/permissions'))
          .map((t) => t.path)
        paths.forEach((p) => removeTab(p))
      }
      // 添加当前路由到标签页
      if (route.path !== '/login') {
        addTab(route)
      }
      document.addEventListener('visibilitychange', refreshUserOnTabVisible)
      document.addEventListener('fullscreenchange', syncFullscreenActive)
      document.addEventListener('webkitfullscreenchange', syncFullscreenActive)
      syncFullscreenActive()

      refreshTaskBadge()
      if (canAccess('orders.delivery.view')) {
        tryImportLocalPackingBatches({ notify: true })
      }
      // 原 30s 轮询过密，易占满 gunicorn；2 分钟 + 仅前台页签请求
      const BADGE_POLL_MS = 120000
      const ONLINE_POLL_MS = 120000
      taskBadgeTimer = setInterval(() => {
        if (document.visibilityState !== 'visible') return
        refreshTaskBadge()
      }, BADGE_POLL_MS)
      window.addEventListener('erp-task-badge-refresh', refreshTaskBadge)
      refreshOnlineOverview()
      onlineOverviewTimer = setInterval(() => {
        if (document.visibilityState !== 'visible') return
        refreshOnlineOverview()
      }, ONLINE_POLL_MS)

      layoutWindowResizeHandler = () => {
        scheduleClampShell()
        scheduleMainLayoutUpdate()
      }
      window.addEventListener('resize', layoutWindowResizeHandler)
      scheduleClampShell()
      nextTick(() => scheduleClampShell())
      setTimeout(scheduleClampShell, 300)
      setTimeout(scheduleClampShell, 800)

      /** 勾选「进系统问全屏」且本会话尚未问过时，弹出一次确认（浏览器要求用户手势，无法用代码静默全屏） */
      nextTick(() => {
        if (!promptFullscreenOnEnter.value || route.path === '/login') return
        try {
          if (sessionStorage.getItem(SESSION_FS_ASKED_KEY)) return
          sessionStorage.setItem(SESSION_FS_ASKED_KEY, '1')
        } catch (e) {
          /* ignore */
        }
        setTimeout(() => {
          ElMessageBox.confirm(
            '是否进入浏览器全屏？可增加表格可用的纵向空间。\n退出：Esc，或右上角「退出全屏」。仍可用 Alt+Tab 切换其它程序。',
            '全屏工作台',
            {
              confirmButtonText: '进入全屏',
              cancelButtonText: '暂不',
              type: 'info',
              distinguishCancelAndClose: true
            }
          )
            .then(() => toggleBrowserFullscreen())
            .catch(() => {})
        }, 500)
      })
      nextTick(() => {
        if (fitInnerRef.value && typeof ResizeObserver !== 'undefined') {
          layoutResizeObserver = new ResizeObserver(() => {
            if (layoutMode.value === 'fit') scheduleMainLayoutUpdate()
          })
          layoutResizeObserver.observe(fitInnerRef.value)
        }
        scheduleMainLayoutUpdate()
      })
    })

    onUnmounted(() => {
      document.removeEventListener('visibilitychange', refreshUserOnTabVisible)
      document.removeEventListener('fullscreenchange', syncFullscreenActive)
      document.removeEventListener('webkitfullscreenchange', syncFullscreenActive)
      if (lockWindowScrollHandler) {
        window.removeEventListener('scroll', lockWindowScrollHandler)
        lockWindowScrollHandler = null
      }
      clearTimeout(layoutResizeTimer)
      clearTimeout(menuResizeTimer)
      clearTimeout(shellClampTimer)
      layoutResizeObserver?.disconnect()
      if (layoutWindowResizeHandler) {
        window.removeEventListener('resize', layoutWindowResizeHandler)
      }
      if (taskBadgeTimer) clearInterval(taskBadgeTimer)
      window.removeEventListener('erp-task-badge-refresh', refreshTaskBadge)
      if (onlineOverviewTimer) clearInterval(onlineOverviewTimer)
    })

    // 监听路由变化，自动添加标签页
    watch(
      () => route.path,
      (newPath) => {
        if (newPath !== '/login') {
          addTab(route)
        }
        scheduleMainLayoutUpdate()
      },
      { immediate: true }
    )

    const canAccessDesktopMobile = computed(() => canAccessDesktopMobileWorkbench(userStore.user))

    const handleLogout = () => {
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const token = localStorage.getItem('token')
        try {
          // 必须先带着旧 token 通知后端下线，再 clearUser；否则会话一直 active，在线列表残留
          if (token) {
            await request({
              url: '/api/auth/logout',
              method: 'post',
              headers: { Authorization: `Bearer ${token}` },
              skipAuthRedirect: true,
              timeout: 8000
            })
          }
        } catch {
          /* 仍继续清本地态 */
        }
        userStore.clearUser()
        router.replace('/login')
      })
    }

    return {
      handleLogout,
      canViewOnlineOverview,
      onlineOverview,
      formatOfflineLogin,
      handleOnlineDropdownVisible,
      currentUserName,
      goChangePassword,
      canAccess,
      canAccessFinance,
      canShowMyReceivablesMenu,
      canAccessDesktopMobile,
      canViewBillingStatements,
      canManageUsersAndRoles,
      canViewBillingPrepayment,
      canViewBillingDocumentCenter,
      canViewPaymentFooterAccounts,
      canViewTaxInvoices,
      showFinanceMenu,
      showOrdersMenu,
      showPurchaseMenu,
      showInventoryMenu,
      showReportsMenu,
      showBasicDataMenu,
      layoutMode,
      isDesktopMobileRoute,
      viewportRef,
      fitBridgeRef,
      fitInnerRef,
      topMenuRef,
      headerRef,
      headerRightRef,
      topMenuWrapRef,
      bridgeStyle,
      innerStyle,
      taskBadge,
      headerNavCollapsed,
      persistHeaderNavCollapsed,
      scheduleClampShell,
      mainContentCompact,
      persistMainContentCompact,
      fullscreenActive,
      toggleBrowserFullscreen,
      promptFullscreenOnEnter,
      persistPromptFullscreenOnEnter
    }
  }
}
</script>

<style scoped>
/*
 * 外壳钉在窗口像素宽（见 --erp-shell-w + clampShellToWindow）。
 */
.layout-container {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: var(--erp-shell-w, 100%);
  min-width: 0;
  overflow: hidden !important;
  box-sizing: border-box;
}

.layout-container > * {
  min-width: 0 !important;
  max-width: 100%;
  box-sizing: border-box;
}

.layout-container > .el-header {
  flex-shrink: 0;
  /* 覆盖 Element Plus 默认左右 20px padding，避免顶栏内容被挤出视口 */
  padding: 0 !important;
}

.layout-container > .main-content {
  flex: 1 1 0%;
  min-height: 0;
  overflow: hidden !important;
}

/* 顶栏：flex + 左侧可缩，右侧固定；菜单区像素宽由 JS 写入 */
.header {
  background-color: #409EFF;
  color: white;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  padding: 0 !important;
  height: 60px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  z-index: 2100;
}

.header-left {
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
}

.header-nav-toggle {
  flex-shrink: 0;
  margin-right: 2px;
  color: #fff !important;
}

/* 菜单铺满左侧可用宽度；溢出项进「⋯」，不要在蓝条上出现横滑条 */
.top-menu-wrap {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

/* 收起顶栏：隐藏系统标题、压缩菜单项 */
.header--nav-collapsed .system-title {
  display: none;
}

.header--nav-collapsed :deep(.top-menu .el-menu-item),
.header--nav-collapsed :deep(.top-menu .el-sub-menu__title) {
  padding: 0 8px !important;
  font-size: 12px !important;
}

.header--nav-collapsed :deep(.top-menu .el-menu-item .el-icon),
.header--nav-collapsed :deep(.top-menu .el-sub-menu__title .el-icon) {
  margin-right: 4px;
}

.system-title {
  font-size: 15px;
  font-weight: bold;
  padding: 0 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

@media (max-width: 1400px) {
  .system-title {
    display: none;
  }
}

.header-fullscreen-btn,
.header-display-btn {
  color: #fff !important;
  padding: 4px 6px !important;
  height: auto !important;
}

.header-fullscreen-btn span,
.header-display-btn span {
  margin-left: 3px;
  white-space: nowrap;
  font-size: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-right: 8px;
  padding-left: 6px;
  min-width: 0;
  flex: 0 0 auto;
  flex-shrink: 0;
}

.el-dropdown-link {
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  max-width: 9em;
}

.header-user-avatar {
  margin-right: 4px;
  flex-shrink: 0;
}

.header-user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.online-users-link {
  color: white;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 12px;
  padding: 3px 8px;
}

.header-display-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 2px 0;
}

.header-display-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.header-display-row--stack {
  flex-direction: column;
  align-items: flex-start;
}

.header-display-row__label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

:deep(.online-users-dropdown .el-dropdown-menu__item.is-disabled) {
  color: #303133;
  opacity: 1;
}

:deep(.online-users-dropdown__section) {
  font-size: 12px;
  font-weight: 600;
  color: #606266 !important;
  cursor: default;
  line-height: 1.4;
}

:deep(.online-users-dropdown__section--secondary) {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
  color: #909399 !important;
}

:deep(.online-users-dropdown__item) {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  min-width: 260px;
  font-size: 13px;
}

:deep(.online-users-dropdown__item--live .online-users-dropdown__name) {
  color: #67c23a;
  font-weight: 500;
}

:deep(.online-users-dropdown__item--live .online-users-dropdown__devices) {
  flex-shrink: 0;
  margin-left: 8px;
  color: #67c23a;
  opacity: 0.85;
  font-size: 12px;
}

:deep(.online-users-dropdown__item--away .online-users-dropdown__name) {
  color: #909399;
}

:deep(.online-users-dropdown__meta) {
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 12px;
  color: #c0c4cc;
}

:deep(.online-users-dropdown__empty) {
  color: #909399 !important;
  font-size: 13px;
}

:deep(.online-users-dropdown__item.online-users-dropdown__empty) {
  justify-content: flex-start;
}

.top-menu {
  background-color: transparent;
  border-bottom: none;
  /* 必须与 wrap 同宽，Element Plus ellipsis 才能按可用宽度折叠到「⋯」 */
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* 确保菜单项内容可见 */
:deep(.top-menu .el-menu-item span),
:deep(.top-menu .el-sub-menu__title span) {
  display: inline-block;
  visibility: visible;
  opacity: 1;
}

/* 水平菜单项样式 */
:deep(.top-menu .el-menu-item) {
  color: #fff !important;
  border-bottom: 2px solid transparent;
  padding: 0 10px !important;
  height: 60px;
  line-height: 60px;
}

:deep(.top-menu .el-menu-item:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}

:deep(.top-menu .el-menu-item.is-active) {
  color: #FFD700 !important;
  border-bottom-color: #FFD700 !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* 下拉菜单标题样式 */
:deep(.top-menu .el-sub-menu__title) {
  color: #fff !important;
  border-bottom: 2px solid transparent;
  padding: 0 10px !important;
  height: 60px;
  line-height: 60px;
}

:deep(.top-menu .el-sub-menu__title:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}

:deep(.top-menu .el-sub-menu.is-active > .el-sub-menu__title) {
  color: #FFD700 !important;
  border-bottom-color: #FFD700 !important;
}

/* 下拉菜单面板样式 - 使用正确的选择器 */
:deep(.el-menu--popup) {
  background-color: #fff !important;
  border: 1px solid #e4e7ed !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  min-width: 160px !important;
  z-index: 2500 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  color: #606266 !important;
  background-color: #fff !important;
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

/* 确保下拉菜单容器可见（须高于标签栏 z-index: 100 与顶栏 2100） */
:deep(.el-sub-menu__popper) {
  z-index: 2500 !important;
}

/* 下拉菜单项文字可见 */
:deep(.el-menu--popup .el-menu-item span) {
  color: inherit !important;
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

:deep(.el-menu--popup .el-menu-item .el-icon) {
  color: inherit !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* 确保下拉菜单项有内容 */
:deep(.el-menu--popup .el-menu-item) {
  white-space: nowrap !important;
}

/* 修复可能被隐藏的菜单项 */
:deep(.el-menu--popup) {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

:deep(.el-menu--popup > *) {
  display: block !important;
  visibility: visible !important;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
  flex: 1 1 0%;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main-content--compact {
  padding: 6px 8px;
}

.main-viewport {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.main-viewport__bridge {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  box-sizing: border-box;
}

.main-viewport--scroll .main-viewport__inner {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.main-viewport__inner {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
}

/* 页面根节点一律不得超过主区宽度（宽表在自身 el-table 内滚） */
.main-viewport__inner > * {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
</style>

<style>
/* 全局样式 - 确保下拉菜单正确显示（因为可能通过 teleport 渲染到 body） */

/* 主壳：整页只允许 .main-viewport 出现滚动条 */
.layout-container.el-container.is-vertical {
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  height: 100% !important;
  max-height: 100% !important;
}
.layout-container > .main-content {
  flex: 1 1 0% !important;
  min-height: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}
.layout-container .main-viewport {
  flex: 1 1 0% !important;
  min-height: 0 !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}
/*
 * 页面级列表表：竖向交给 .main-viewport，表内只保留横滑，避免「双竖条」。
 * 弹窗/抽屉内、以及需要内嵌竖滚的表（max-height → el-table--scrollable-y）必须恢复竖条。
 */
.main-viewport .el-table:not(.el-table--scrollable-y),
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__inner-wrapper,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__body-wrapper,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar__wrap,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar__view {
  height: auto !important;
  max-height: none !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__inner-wrapper {
  display: block !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__body-wrapper {
  flex: none !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar {
  overflow: visible !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar__wrap {
  overflow-x: auto !important;
  overflow-y: hidden !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar__view {
  display: block !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-scrollbar__bar.is-vertical {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
.main-viewport .el-table .el-scrollbar__bar.is-horizontal {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  height: 6px !important;
  left: 2px !important;
  right: 2px !important;
  bottom: 2px !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__fixed .el-table__body-wrapper,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__fixed-right .el-table__body-wrapper,
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__fixed-body-wrapper {
  overflow: hidden !important;
  height: auto !important;
  max-height: none !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) .el-table__fixed-right-patch,
.main-viewport .el-table:not(.el-table--scrollable-y) th.el-table__cell.gutter,
.main-viewport .el-table:not(.el-table--scrollable-y) td.el-table__cell.gutter {
  display: none !important;
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: none !important;
}
.main-viewport .el-table:not(.el-table--scrollable-y) col[name='gutter'] {
  width: 0 !important;
}

/* 弹窗/抽屉内表格：完整恢复内嵌竖向滚动（含 max-height）
 * 页面级 el-table--scrollable-y 也 revert，但预告单明细表（.forecast-detail-table）除外，
 * 否则会清掉 max-height，表头无法冻结。 */
.main-viewport .el-dialog .el-table,
.main-viewport .el-dialog .el-table__inner-wrapper,
.main-viewport .el-dialog .el-table__body-wrapper,
.main-viewport .el-dialog .el-table .el-scrollbar,
.main-viewport .el-dialog .el-table .el-scrollbar__wrap,
.main-viewport .el-dialog .el-table .el-scrollbar__view,
.main-viewport .el-drawer .el-table,
.main-viewport .el-drawer .el-table__inner-wrapper,
.main-viewport .el-drawer .el-table__body-wrapper,
.main-viewport .el-drawer .el-table .el-scrollbar,
.main-viewport .el-drawer .el-table .el-scrollbar__wrap,
.main-viewport .el-drawer .el-table .el-scrollbar__view,
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table),
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table) .el-table__inner-wrapper,
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table) .el-table__body-wrapper,
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table) .el-scrollbar,
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table) .el-scrollbar__wrap,
.main-viewport .el-table.el-table--scrollable-y:not(.forecast-detail-table) .el-scrollbar__view {
  height: revert !important;
  max-height: revert !important;
}
.main-viewport .el-dialog .el-table__body-wrapper,
.main-viewport .el-dialog .el-table .el-scrollbar__wrap,
.main-viewport .el-drawer .el-table__body-wrapper,
.main-viewport .el-drawer .el-table .el-scrollbar__wrap,
.main-viewport .el-table.el-table--scrollable-y .el-table__body-wrapper,
.main-viewport .el-table.el-table--scrollable-y .el-scrollbar__wrap {
  overflow-x: auto !important;
  overflow-y: auto !important;
  flex: unset !important;
}
.main-viewport .el-dialog .el-table .el-scrollbar,
.main-viewport .el-drawer .el-table .el-scrollbar,
.main-viewport .el-table.el-table--scrollable-y .el-scrollbar {
  overflow: hidden !important;
}
.main-viewport .el-dialog .el-table .el-scrollbar__bar.is-vertical,
.main-viewport .el-drawer .el-table .el-scrollbar__bar.is-vertical,
.main-viewport .el-table.el-table--scrollable-y .el-scrollbar__bar.is-vertical {
  display: block !important;
  visibility: visible !important;
  width: 6px !important;
  height: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
}
/* teleport 到 body 的弹窗同样保障竖条（不在 .main-viewport 内时上面规则够不到） */
.el-overlay .el-dialog .el-table .el-scrollbar__bar.is-vertical,
.el-overlay .el-drawer .el-table .el-scrollbar__bar.is-vertical {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
}
.el-overlay .el-dialog .el-table__body-wrapper,
.el-overlay .el-dialog .el-table .el-scrollbar__wrap,
.el-overlay .el-drawer .el-table__body-wrapper,
.el-overlay .el-drawer .el-table .el-scrollbar__wrap {
  overflow-x: auto !important;
  overflow-y: auto !important;
}
/* 桌面内嵌移动工作台：外层不再滚，只让 .m-main 滚，避免双竖条 */
.layout-container .main-viewport.main-viewport--nested-scroll {
  overflow: hidden !important;
}
.layout-container .main-viewport.main-viewport--nested-scroll .main-viewport__bridge,
.layout-container .main-viewport.main-viewport--nested-scroll .main-viewport__inner {
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}
.layout-container .main-viewport.main-viewport--nested-scroll .main-viewport__inner > * {
  height: 100%;
  max-height: 100%;
}
/* 兜底：若别处仍残留 el-main，禁止它再出滚动条 */
.layout-container > .el-main {
  flex: 1 1 0% !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.el-menu--popup {
  background-color: #fff !important;
  border: 1px solid #e4e7ed !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  min-width: 160px !important;
  z-index: 2500 !important;
  padding: 4px 0 !important;
}

.el-menu--popup .el-menu-item {
  color: #606266 !important;
  background-color: #fff !important;
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
  white-space: nowrap !important;
}

.el-menu--popup .el-menu-item:hover {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

.el-menu--popup .el-menu-item.is-active {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

.el-menu--popup .el-menu-item span {
  color: inherit !important;
  display: inline-block !important;
}

.el-menu--popup .el-menu-item .el-icon {
  color: inherit !important;
  margin-right: 8px !important;
}

/* 弹出层内子菜单标题：避免继承顶栏 menu 的白色 text-color 导致白底上看不见 */
.el-menu--popup .el-sub-menu__title {
  color: #606266 !important;
}

.el-menu--popup .el-sub-menu__title:hover {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

/*
 * 小屏顶栏横向菜单放不下时会折叠进「⋯」弹出层（ellipsis）。
 * 顶栏 text-color=#fff 会延续到该弹出层，而弹出层背景为白 → 子菜单标题白底白字，表现为大片「空白」，
 * 仅末尾若干 el-menu-item（全局已为 .el-menu--popup .el-menu-item 设深色字）能看见。
 */
.top-menu-overflow-popper.el-menu--popup,
.top-menu-overflow-popper .el-menu--popup {
  --el-menu-text-color: #303133;
  --el-menu-hover-text-color: #409eff;
  --el-menu-active-color: #409eff;
}

.top-menu-overflow-popper .el-sub-menu__title,
.top-menu-overflow-popper .el-menu .el-sub-menu__title {
  color: #606266 !important;
}

.top-menu-overflow-popper .el-sub-menu__title:hover,
.top-menu-overflow-popper .el-sub-menu.is-active > .el-sub-menu__title {
  color: #409eff !important;
}

.top-menu-overflow-popper .el-sub-menu__title .el-icon {
  color: inherit !important;
}

/* 顶栏「显示」设置弹出层（popover 挂到 body） */
.header-display-popper {
  z-index: 2600 !important;
}

.header-display-popper .header-layout-rg .el-radio-button__inner {
  padding: 5px 10px;
}

/* 顶栏子菜单 / 溢出菜单弹出层：高于标签栏，避免下拉项被白条遮挡 */
.el-sub-menu__popper,
.top-menu-overflow-popper {
  z-index: 2500 !important;
}
</style>